import { useContext } from 'react'; 
import SettingsContext from 'src/devias/contexts/SettingsContext';

const useSettings = () => useContext(SettingsContext);

export default useSettings;
